import { useCallback, useEffect, useState, useRef } from 'react';
import * as React from 'react';
import { SelectAutoCompleteOptions } from '../shared/types/selectAutoComplete';
import TipoPagamentoController from '../controllers/TipoPagamentoController';
import { Item } from '../shared/components/InputSelect';
import { useForm } from './useForm';
import { PedidoDetalheSchema } from '../schemas/PedidoDetalheSchema';
import ClienteController from '../controllers/ClienteController';
import { debounce } from '@mui/material';
import CondicaoPagamentoController from '../controllers/CondicaoPagamentoController';
import ProdutoController from '../controllers/ProdutoController';
import { PedidoProdutoSchema } from '../schemas/PedidoProdutoSchema';
import CentroCustoController from '../controllers/CentroCustoController';
import PedidoController from '../controllers/PedidoController';
import { formatarData } from '../shared/utils/helpers/date';
import {
  condicaoEhAvista,
  condicoesPermitidas,
  descricaoEhFormaAvista,
} from '../shared/utils/helpers/formaCondicaoPagamento';
import BoletoController from '../controllers/BoletoController';
import { toast } from 'react-toastify';
import {
  CheckCircle,
  ErrorSharp,
  RemoveCircleOutline,
} from '@mui/icons-material';
import { Pedido, ProdutoCadastrar } from '../routes/RoutesNames';
import { removeSpecialCharacters } from '../shared/utils/helpers/string';
import { getAddressData } from '../services/external/viacep/getCep';
import CfopController from '../controllers/CfopController';
import ImpostoController from '../controllers/ImpostoController';
import { PedidoServicoSchema } from '../schemas/PedidoServicoSchema';
// Api e downloadBase64 saíram com a geração de recibos (12/08/2026) - eram usados só
// por ela. Se voltarem a ser necessários aqui, reimportar.

const TIPO_PAGAMENTO_BOLETO_ID = 3;

export const usePedidoDetalhes = (id?: string, clonarParam?: any) => {
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState('0');
  const [customerOptions, setCustomerOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [sellerOptions, setSellerOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [transportOptions, setTransportOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [paymentOptions, setPaymentOptions] = useState<Item[]>([]);
  const [costCenterOptions, setCostCenterOptions] = useState<Item[]>([]);
  const [paymentConditionOptions, setSetPaymentConditionOptions] = useState<
    Item[]
  >([]);
  const [cfopOptions, setCfopOptions] = useState<Item[]>([]);
  const [modalSearchProduct, setModalSearchProduct] = useState<boolean>(false);
  const [modalSearchService, setModalSearchService] = useState<boolean>(false);
  const [showCreateProduct, setShowCreateProduct] = useState(false);
  const [productOptions, setProductOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [allProductList, setAllProductList] = useState<any[]>([]);
  const [allCodigoTributarioList, setAllCodigoTributarioList] = useState<any[]>(
    []
  );
  const [allCodigoNBSList, setAllCodigoNBSList] = useState<any[]>([]);
  const [codigoTributarioOptions, setCodigoTributarioOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [codigoNBSOptions, setCodigoNBSOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);
  const [activeCodigoTributarioSelected, setActiveCodigoTributarioSelected] =
    useState<any>({});
  const [activeCodigoNBSSelected, setActiveCodigoNBSSelected] = useState<any>(
    {}
  );
  const [activeProductSelected, setActiveProductSelected] = useState<any>({});
  const [activeServiceSelected, setActiveServiceSelected] = useState<any>({});
  const [productIsEditing, setProductIsEditing] = useState<boolean>(false);
  const [serviceIsEditing, setServiceIsEditing] = useState<boolean>(false);
  const [BoletoOpen, BoletoSetOpen] = useState(false);
  const [boletoApiResponse, setBoletoApiResponse] = useState<any[]>([]);
  const [boletoPId, setBoletoPId] = useState<number | null>(null);
  const [boletoReprocessing, setBoletoReprocessing] = useState(false);
  const [customerList, setCustomerList] = useState<any[]>([]);
  const [tabs, setTabs] = useState<any>([
    {
      id: '0',
      label: 'Finalidade',
      value: 'finalidade',
      touched: false,
    },
    {
      id: '1',
      label: 'Cadastro',
      value: 'cadastro',
      touched: false,
    },
    {
      id: '2',
      label: 'Produtos',
      value: 'products_list',
      touched: false,
    },
    {
      id: '3',
      label: 'Serviços',
      value: 'services_list',
      touched: false,
    },
    {
      id: '4',
      label: 'Locação',
      value: 'locacao',
      touched: false,
    },
    // [30/09] Transporte ANTES do Financeiro - pedido do Deivid. A previa das parcelas
    // soma o frete (mesma conta da FN_VENDA_TOTAL_LIQUIDO); com o Financeiro antes, o
    // operador via parcelas sem frete e so descobria o valor certo voltando a aba.
    //
    // Os ids foram trocados junto com a ordem: o id E a posicao (ver o comentario do
    // Dados adicionais abaixo). E o TabPanel de cada componente usa o mesmo numero.
    {
      id: '5',
      label: 'Transporte',
      value: 'transporte',
      touched: false,
    },
    {
      id: '6',
      label: 'Financeiro',
      value: 'financeiro',
      touched: false,
    },
    {
      // [CORRIGIDO 21/09/2026] O id NAO e so uma chave: handleNext faz
      // parseInt(tabIndex) + 1 e os botoes comparam com tabs.length - 1, entao ele e o
      // INDICE DA POSICAO. Com esta guia em '8' e o Finalizar em '7', o Salvar aparecia
      // aqui e o Finalizar mostrava "Proximo".
      id: '7',
      label: 'Dados adicionais',
      value: 'dados_adicionais',
      touched: false,
    },
    {
      id: '8',
      label: 'Finalizar',
      value: 'finalizar',
      touched: false,
    },
  ]);

  const TAB_IDS = {
    FINALIDADE: '0',
    CADASTRO: '1',
    PRODUTOS: '2',
    SERVICOS: '3',
    LOCACAO: '4',
    TRANSPORTE: '5',
    FINANCEIRO: '6',
    FINALIZAR: '8',
  };

  const clonarRef = useRef(clonarParam);
  if (clonarParam === 'S') {
    clonarRef.current = 'S';
  }

  /* [REMOVIDO 12/08/2026] A geração de recibos SAIU do salvar da locação.
   *
   * Antes, salvar um contrato de 12 meses emitia os 12 recibos de uma vez - inclusive os
   * de meses que ainda não venceram - e baixava um .zip que ninguém tinha pedido.
   *
   * Agora o recibo é emitido na tela de **Contas a Receber**: filtra-se a Finalidade em
   * "Locação", o período desejado, e o botão "Gerar Recibos" emite apenas as parcelas
   * que a busca trouxe. O número passou a ser sequencial (EMPRESA.emp_recibo_sequencia)
   * e fica gravado em CONTASRECEBER.cre_recibo_numero, o que também permitiu a 2ª via
   * por linha, com o número original.
   *
   * O endpoint api/relatorio/RecibosLocacao (por venda) continua existindo e não foi
   * mexido - só deixou de ser chamado daqui.
   */

  // Uma maquina nao pode figurar duas vezes no mesmo contrato: remove repeticoes de
  // prod_id antes de enviar, para nao gravar item duplicado em VENDALOCACAOITEM.
  const dedupLocacaoList = (data: any) => {
    const lista = data?.locacao?.locacao_list;
    if (!Array.isArray(lista) || lista.length < 2) return data;
    const vistos = new Set<number>();
    const unicos = lista.filter((item: any) => {
      const pid = Number(item?.prod_id);
      if (!pid || vistos.has(pid)) return false;
      vistos.add(pid);
      return true;
    });
    if (unicos.length === lista.length) return data;
    return { ...data, locacao: { ...data.locacao, locacao_list: unicos } };
  };

  // Os totais do financeiro sao valores DERIVADOS (produtos + servicos + locacao) e eram
  // preenchidos por uma cadeia de useEffect (locacao.valor -> total_liquido_locacao ->
  // total_geral). Em locacao o total_geral chegava 0 no payload mesmo com a tela mostrando
  // o valor certo, e como a geracao de parcelas usa esse campo, as parcelas saiam zeradas.
  // Recalcular no envio elimina a dependencia da ordem dos efeitos.
  // [BONIFICACAO 14/08/2026] Item bonificado = CFOP terminado em 910 (5910 interna,
  // 6910 interestadual). O campo da tela e "grupo_tributario", que aponta para CFOP.cfo_id.
  // Espelha a FN_CFOP_BONIFICACAO do banco - se a regra mudar, muda nos dois.
  const itemEhBonificado = (item: any) => {
    const cfop = String(item?.grupo_tributario ?? '');
    return cfop.length >= 3 && cfop.slice(-3) === '910';
  };

  // Venda INTEGRALMENTE bonificada: so produtos, todos bonificados, sem servico e sem
  // locacao. Nao ha toggle novo na tela - a marcacao e DERIVADA dos itens, igual ao banco
  // (o cobravel zero e o que decide). Venda MISTA nao entra aqui: ela tem parte cobravel e
  // segue exigindo forma, condicao e frete normais.
  const ehBonificacaoIntegral = (data: any) => {
    const produtos = Array.isArray(data?.products_list) ? data.products_list : [];
    const servicos = Array.isArray(data?.services_list) ? data.services_list : [];
    const locacao = Number(data?.locacao?.valor ?? 0) || 0;

    if (produtos.length === 0) return false;
    if (servicos.length > 0 || locacao > 0) return false;

    return produtos.every(itemEhBonificado);
  };

  const comTotaisRecalculados = (data: any) => {
    const num = (v: any) => {
      const n = Number(v ?? 0);
      return Number.isFinite(n) ? n : 0;
    };
    const produtos = num(data?.financeiro?.total_liquido_produtos);
    const servicos = num(data?.financeiro?.total_liquido_servicos);
    const locacao = num(data?.locacao?.valor);
    const totalGeral = produtos + servicos + locacao;

    // A PROC_VENDA_GRAVAR le campos DIFERENTES nos dois ramos:
    //   inclusao  -> $.finalizar.total_liquido_pedido
    //   alteracao -> $.financeiro.total_geral
    // Por isso os dois precisam ir corretos. O liquido espelha handleTotalLiquidoPedido:
    // bruto - descontos dos itens + frete (frete so entra em CIF ou modalidade 1).
    const somaDesconto = (lista: any) =>
      Array.isArray(lista)
        ? lista.reduce((acc: number, item: any) => acc + num(item?.desconto), 0)
        : 0;
    const descontos = somaDesconto(data?.products_list) + somaDesconto(data?.services_list);
    const modFrete = data?.transporte?.mod_frete;
    const frete =
      String(modFrete) === '1' || data?.transporte?.somar_frete_cif === 'S'
        ? num(data?.transporte?.valor_frete)
        : 0;

    return {
      ...data,
      financeiro: {
        ...data?.financeiro,
        total_liquido_produtos: produtos,
        total_liquido_servicos: servicos,
        total_liquido_locacao: locacao,
        total_geral: totalGeral,
      },
      finalizar: {
        ...data?.finalizar,
        total_locacao_bruto: locacao,
        total_descontos: descontos,
        desconto_itens: descontos,
        total_liquido_pedido: totalGeral - descontos + frete,
      },
    };
  };

  // Trava contra dois cliques no Salvar.
  //
  // Isto não é zelo preventivo: entre 05/08 e 12/08/2026 nasceram SEIS pedidos
  // duplicados em produção (218/219, 227/228, 216/217, 206/207, 184/185,
  // 134/135), todos com ids consecutivos, mesmo usuário, mesmos itens, de 1 a 3
  // segundos de diferença. É o tempo de um clique duplo enquanto a primeira
  // requisição ainda está no ar.
  //
  // A trava fica no onSubmit, e não só no `disabled` do botão, porque é aqui que
  // o POST sai. O botão pode ser reacionado por Enter no formulário, e o
  // `disabled` só vale a partir do render seguinte - um ref é síncrono.
  const enviandoRef = useRef(false);

  const onSubmit = async (rawData: any) => {
    if (enviandoRef.current) {
      return;
    }
    enviandoRef.current = true;

    setLoading(true);
    let statusCode;
    try {
      const data = comTotaisRecalculados(dedupLocacaoList(rawData));
      const deveClonar = clonarRef.current === 'S';
      if (id && !deveClonar) {
        const result = await PedidoController.PedidoAtualizar(data, id);
        statusCode = result.StatusCode;
        // [REMOVIDO 12/08/2026] Aqui gerava os recibos da locação. Ver o comentário na
        // antiga gerarRecibosLocacao: agora é o botão do Contas a Receber que emite.
        if (statusCode === 204) {
          toast('Pedido atualizado com sucesso', {
            type: 'success',
            autoClose: 1000,
            onClose: () => {
              window.location.href = '/dashboard/pedido';
            },
          });
        }
      } else if (deveClonar || !id) {
        //garante que o vnd_id seja null durante a copia
        const payload = {
          ...data,
        };
        if (payload.cadastro) {
          payload.cadastro.vnd_id = null;
        }
        const result = await PedidoController.PedidoAdicionar(payload);
        statusCode = result.StatusCode;
        if (statusCode === 200 || statusCode === 201) {
          const pId = result.Data?.[0]?.NotaEntradaId;
          // [REMOVIDO 12/08/2026] idem: a geração de recibos saiu daqui.
          if (payload.financeiro.tpg_id === TIPO_PAGAMENTO_BOLETO_ID && pId) {
            toast('Pedido adicionado com sucesso. Boletos em processamento ...', {
              type: 'success',
              autoClose: 1500,
            });
            setBoletoPId(pId);
            const res = await BoletoController.Gerar(pId);
            setBoletoApiResponse(res.Data);
            BoletoSetOpen(true);
          }
          else {
            toast('Pedido adicionado com sucesso. Atualizando ...', {
              type: 'success',
              autoClose: 1000,
              onClose: () => {
                window.location.href = '/dashboard/pedido';
              },
            });
          }
        }
      }
    } finally {
      setLoading(false);

      // Só devolve o botão quando NÃO salvou. Depois de salvar, a tela ainda
      // fica 1 a 1,5 segundo mostrando o toast antes de navegar (e no caminho do
      // boleto fica aberta no diálogo) - liberar aqui reabriria exatamente a
      // janela que criou as duplicatas.
      //
      // O finally existe para o caso de erro: sem ele, uma exceção em
      // gerarRecibosLocacao ou na geração do boleto deixaria o Salvar travado
      // para sempre, e ficar sem poder salvar é pior que salvar duas vezes.
      const salvou =
        statusCode === 200 || statusCode === 201 || statusCode === 204;
      if (!salvou) {
        enviandoRef.current = false;
      }
    }

    if (statusCode !== 200 && statusCode !== 201 && statusCode !== 204) {
      toast('Houve um erro ao tentar salvar pedido. Revise os dados!', {
        type: 'error',
      });
    }
  };

  const boletoHandleOk = () => {
    BoletoSetOpen(false);
    window.location.href = '/dashboard/pedido';
  };

  // Reprocessa os boletos: re-chama gerarBoleto da mesma venda.
  // A PROC_BB_BOLETO_REGISTRAR pula os CREs que ja tem boleto, entao so os que
  // falharam sao reenviados (nao duplica os que deram certo).
  const handleReprocessarBoletos = async () => {
    if (!boletoPId) return;
    setBoletoReprocessing(true);
    try {
      const res = await BoletoController.Gerar(boletoPId);
      setBoletoApiResponse(
        (res.Data ?? []).filter((x: any) => x && typeof x === 'object')
      );
    } finally {
      setBoletoReprocessing(false);
    }
  };

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: {
      parcelas: [],
      transporte: {
        placa_veiculo: '',
        uf_placa_veiculo: '',
        mod_frete: null,
        somar_frete_cif: 'S',
      },
      cadastro: {
        placa_veiculo: '',
        tabela_preco: '',
        data_emissao: new Date().toISOString().split('T')[0],
        data_entrega: new Date().toISOString().split('T')[0],
        cli_id: 1,
        cli_nome: null,
        cli_cep: '',
        cli_uf: '',
        cli_cidade: '',
        cli_bairro: '',
        cli_endereco: '',
        cli_numero: '',
        cli_complemento: '',
        vend_id: null,
        vend_nome: '',
        // [CARD DADOS ADICIONAIS] Vai para VENDA.vnd_obs: a PROC_VENDA_GRAVAR ja lia
        // $.cadastro.observacao e a LISTAR_UNICO ja devolvia - faltava a tela mandar.
        observacao: '',
        // [24/09, item 1 do teste de 23/09] Só LEITURA: de onde este documento veio.
        // Vazio num pedido digitado do zero; numa devolução, 'Venda' + o id devolvido;
        // num pedido gerado por OS, 'Ordem de Servico' + o id dela. A PROC_VENDA_GRAVAR
        // não lê estes caminhos, então mandá-los de volta é inofensivo.
        vnd_origem: '',
        vnd_origemID: null,
        vnd_especie_doc: '',
      },
      finalidade: {
        finalidade: '',
      },
      finalizar: {
        total_descontos: null,
        total_bruto_produtos: null,
        total_servicos_bruto: null,
        total_locacao_bruto: null,
        total_liquido_pedido: null,
        desconto_itens: null,
        valor_frete: null,
      },
      financeiro: {
        total_descontos: '',
        total_liquido_produtos: null,
        total_liquido_servicos: null,
        total_liquido_locacao: null,
        total_geral: null,
        gerar_financeiro: true,
        data_referencia: new Date().toISOString().split('T')[0],
        tpg_id: null,
        cpg_id: null,
        bandeira: null,
        cc_id: null,
        // [24/09] O campo saiu da tela, mas continua sendo ENVIADO como 'N': a
        // PROC_VENDA_GRAVAR lê $.financeiro.recebimento_unico e grava a coluna. Tirar do
        // payload gravaria nulo onde hoje há 'N', sem ganho nenhum.
        recebimento_unico: 'N',
        parcelas: [],
      },
      locacao: {
        recorrencia: '',
        dataInicio: new Date().toISOString().split('T')[0],
        dataFim: new Date().toISOString().split('T')[0],
        valor: 0.0,
        locacao_list: [],
      },
      products_list: [],
      services_list: [],
    },
    validationSchema: PedidoDetalheSchema,
  });

  const onSubmitProduct = async (data: any) => {
    form.setFieldValue('parcelas', []);
    if (activeProductSelected?.id != null && productIsEditing) {
      form.setFieldValue(`products_list[${activeProductSelected.id}]`, data);
      toast('Produto atualizado com sucesso', { type: 'success' });
    } else {
      form.setFieldValue('products_list', [
        ...form.values.products_list,
        { ...activeProductSelected, ...data },
      ]);
      toast('Produto adicionado com sucesso', { type: 'success' });
    }
    handleCloseModalSearchProduct();
  };

  const onSubmitService = async (data: any) => {
    if (activeServiceSelected?.id != null && serviceIsEditing) {
      form.setFieldValue(`services_list[${activeServiceSelected.id}]`, data);
      toast('Serviço atualizado com sucesso', { type: 'success' });
    } else {
      form.setFieldValue('services_list', [
        ...form.values.services_list,
        { ...activeServiceSelected, ...data },
      ]);
      toast('Serviço adicionado com sucesso', { type: 'success' });
    }
    handleCloseModalSearchService();
  };

  const formProduct = useForm({
    onSubmit: onSubmitProduct,
    initialValues: {
      desconto: 0.0,
      quantidade: 1,
      value: 0.0,
      seguro: 0.0,
      peso_liquido_kg: 0,
      peso_bruto_kg: 0,
      estoque: 0,
    },
    validationSchema: PedidoProdutoSchema,
  });

  const formService = useForm({
    onSubmit: onSubmitService,
    initialValues: {
      desconto: 0,
      quantidade: 1,
      value: 0,
    },
    validationSchema: PedidoServicoSchema,
  });

  const handleResetFormProduct = () => {
    // @ts-ignore - .
    formProduct.resetForm();
  };

  const handleResetFormService = () => {
    // @ts-ignore - .
    formService.resetForm();
  };

  const handlePaymentOptions = useCallback(async () => {
    const result = await TipoPagamentoController.Listar({
      Descricao: '',
    });
    if (result.StatusCode === 200) {
      setPaymentOptions(
        result.Data.map((item: any) => ({
          value: item.tpg_id,
          label: item.tpg_descricao,
        }))
      );
    }
  }, []);

  const handleCostCenterOptions = useCallback(async () => {
    const result = await CentroCustoController.Listar({
      Descricao: '',
    });
    if (result.StatusCode === 200) {
      setCostCenterOptions(
        result.Data.map((item: any) => ({
          value: item.cc_id,
          label: item.cc_descricao,
        }))
      );
    }
  }, []);

  const handleCfopOptions = useCallback(async () => {
    const res = await CfopController.Listar({
      UsuId: 0,
      cfop_Descricao: '',
      cfop_Tipo: 'T',
      cfop_Venda: '',
      Data_Inicio: formatarData(new Date()),
      Data_Fim: formatarData(new Date()),
    });
    const options = (res.Data || []).map((v: any) => ({
      value: v.cfo_id?.toString(),
      label: `${v.cfo_id?.toString()} - ${v.cfo_descricao} (${v.tipo})`,
    }));
    setCfopOptions(options);
  }, []);

  const handlePaymentConditionOptions = useCallback(async () => {
    const result = await CondicaoPagamentoController.Listar({
      Descricao: '',
      Quantidade: '',
      TipoParcelamento: '',
      TipoUtilizacao: '',
      QtdMaiorZero: 'S',
    });
    if (result.StatusCode === 200) {
      setSetPaymentConditionOptions(
        result.Data.map((item: any) => ({
          value: item.cpg_id,
          label: item.cpg_descricao,
        }))
      );
    }
  }, []);

  // ---------------------------------------------------------------------------
  // Amarração entre FORMA e CONDIÇÃO de pagamento
  // ---------------------------------------------------------------------------
  // Regra: "à vista" só existe com dinheiro, cartão de débito ou PIX.
  //
  // A FORMA manda na CONDIÇÃO, e nunca o contrário. A primeira versão bloqueava nos
  // dois sentidos e tinha dois defeitos, encontrados pelo Deivid em 07/08:
  //
  //   1. só desabilitava a opção "A VISTA" - nunca as opções a prazo -, então
  //      dinheiro + "30 60 dias" passava;
  //   2. DEADLOCK: com boleto + 30 dias, trocar para dinheiro exigia antes pôr
  //      "A VISTA", que estava bloqueada porque a forma não era à vista. Não havia
  //      saída sem limpar tudo.
  //
  // Sendo unidirecional, o select de forma fica SEMPRE liberado e o deadlock deixa
  // de existir. A condição só abre depois da forma, e só com o que combina com ela.
  //
  // A identificação é pela DESCRIÇÃO da forma de pagamento, por decisão do cliente:
  // no processo deles o código fiscal dos dois cartões é 99 ("Outros") de propósito,
  // então débito e crédito não se distinguem por ele.
  //
  // Casa por palavra-chave, com a descrição normalizada (maiúsculas, sem acento):
  //   "Dinheiro em espécie" -> DINHEIRO
  //   "Pix"                 -> PIX
  //   "Cartão de Débito"    -> DEBITO   (e "Cartão de Crédito" não casa, como deve ser)
  //
  // Por palavra-chave e não por igualdade para que variações do cadastro
  // ("PIX Banco X", "Dinheiro/espécie") continuem sendo reconhecidas.
  // [24/09] As palavras-chave, o CPG_ID_AVISTA e a normalização saíram daqui para
  // shared/utils/helpers/formaCondicaoPagamento: a tela de devolução usa a MESMA regra,
  // e duas cópias divergem no primeiro ajuste feito só de um lado.
  const formaEhAvista = (tpgId: any) => {
    if (tpgId === null || tpgId === undefined || tpgId === '') return false;
    const forma = paymentOptions.find(
      (item) => Number(item.value) === Number(tpgId)
    );
    return descricaoEhFormaAvista(forma?.label);
  };

  const tpgIdSelecionado = form.values?.financeiro?.tpg_id;
  const cpgIdSelecionado = form.values?.financeiro?.cpg_id;

  const temFormaSelecionada =
    tpgIdSelecionado !== null &&
    tpgIdSelecionado !== undefined &&
    tpgIdSelecionado !== '';

  // A forma nunca é bloqueada - é ela que destrava a condição.
  const paymentOptionsComRegra = paymentOptions;

  const formaSelecionadaEhAvista = formaEhAvista(tpgIdSelecionado);

  // Sem forma escolhida, a condição fica indisponível (o select inteiro é
  // desabilitado na tela). Com forma escolhida, sobra só o que combina:
  //   forma à vista  -> somente "A VISTA"
  //   forma a prazo  -> tudo MENOS "A VISTA"
  const paymentConditionOptionsComRegra = condicoesPermitidas(
    paymentConditionOptions,
    formaSelecionadaEhAvista,
    temFormaSelecionada
  );

  // Trocar a forma para um tipo incompatível limpa a condição, senão o par inválido
  // ficaria salvo mesmo com a opção desabilitada na lista.
  //
  // O ref existe para isto NÃO rodar na carga: pedido antigo com par inconsistente
  // perderia a condição só por ser aberto, e bastaria salvar para gravar o vazio.
  // Só limpa quando o usuário muda a forma de fato.
  const tpgAnteriorRef = useRef<any>(undefined);
  useEffect(() => {
    const anterior = tpgAnteriorRef.current;
    tpgAnteriorRef.current = tpgIdSelecionado;

    if (anterior === undefined || anterior === tpgIdSelecionado) return;
    if (!tpgIdSelecionado || !cpgIdSelecionado) return;

    if (condicaoEhAvista(cpgIdSelecionado) !== formaEhAvista(tpgIdSelecionado)) {
      form.setFieldValue('financeiro.cpg_id', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tpgIdSelecionado]);

  // ---------------------------------------------------------------------------
  // Reprocessar boleto
  // ---------------------------------------------------------------------------
  // Habilita só com a venda salva, com boleto já gerado, e nenhum deles em aberto
  // ou liquidado. Quem decide é o servidor (PROC_VENDA_BOLETO_PODE_REPROCESSAR) -
  // aqui só refletimos o veredito e mostramos o motivo.
  const [reprocessarBoleto, setReprocessarBoleto] = useState<any>(null);
  const [reprocessandoBoleto, setReprocessandoBoleto] = useState(false);

  const carregarPodeReprocessarBoleto = useCallback(async () => {
    // Em inclusão não há venda para avaliar.
    if (!id) {
      setReprocessarBoleto({
        podeReprocessar: false,
        motivo: 'A venda precisa ser salva antes de reprocessar boletos.',
      });
      return;
    }
    setReprocessarBoleto(await BoletoController.PodeReprocessar(Number(id)));
  }, [id]);

  useEffect(() => {
    carregarPodeReprocessarBoleto();
  }, [carregarPodeReprocessarBoleto]);

  /* [30/09] Venda com boleto VIVO (em aberto ou liquidado) nao muda o que foi cobrado -
   * pedido do Deivid. Produto, servico, locacao, frete, credito e pagamento travam.
   *
   * Motivo, medido em producao no script 147: editar a venda apagava os titulos e gerava
   * parcelas novas SEM boleto, e o boleto antigo seguia registrado no banco - 35 boletos
   * em 31 vendas (R$ 35.123,89) cobrando o cliente sem aparecer no sistema.
   *
   * Por boleto VIVO e nao pela forma de pagamento: boleto que falhou ou foi cancelado
   * precisa deixar a venda editavel - e assim que se corrige e gera de novo. A regra e a
   * mesma que decide o botao "Gerar boleto" (PROC_VENDA_BOLETO_PODE_REPROCESSAR), e o
   * banco repete a trava na gravacao (script 148): isto aqui e so para o operador nao
   * descobrir no Salvar.
   *
   * Clonar gera venda NOVA: nao herda a trava da original. */
  const travadoPorBoleto =
    !!id && clonarRef.current !== 'S'
    && (Number(reprocessarBoleto?.qtdEmAberto ?? 0)
        + Number(reprocessarBoleto?.qtdLiquidados ?? 0)) > 0;

  const handleReprocessarBoletoVenda = async () => {
    if (!id) return;
    setReprocessandoBoleto(true);
    try {
      const res = await BoletoController.Reprocessar(Number(id));

      if (res.StatusCode === 200) {
        toast('Boletos reprocessados com sucesso!', { type: 'success' });
      } else {
        // O 400 traz o motivo da recusa; os outros, a mensagem do dicionário.
        toast(
          typeof res.Data === 'string'
            ? res.Data
            : 'Não foi possível reprocessar os boletos.',
          { type: 'error' }
        );
      }
    } finally {
      setReprocessandoBoleto(false);
      // Reavalia sempre: depois de gerar, a venda deixa de estar elegível.
      await carregarPodeReprocessarBoleto();
    }
  };

  const isTabBlocked = useCallback(
    (tabId: string) => {
      const finalidade = form.values?.finalidade?.finalidade;
      const isLocacao = finalidade === 'Locação';

      if (isLocacao) {
        // Se for Locação, bloqueia Produtos e Serviços
        return [TAB_IDS.PRODUTOS, TAB_IDS.SERVICOS].includes(tabId);
      } else {
        // Se NÃO for Locação, bloqueia a aba Locação
        return tabId === TAB_IDS.LOCACAO;
      }
    },
    [form.values?.finalidade?.finalidade]
  );

  const markTabTouched = (tabId: string) => {
    setTabs((prevTabs: any[]) =>
      prevTabs.map((tab) =>
        tab.id === tabId ? { ...tab, touched: true } : tab
      )
    );
  };

  const handleNext = () => {
    // marca a aba atual como visitada ao avançar
    markTabTouched(tabIndex);

    let nextIndex = parseInt(tabIndex) + 1;

    while (nextIndex < tabs.length && isTabBlocked(nextIndex.toString())) {
      nextIndex++;
    }

    if (nextIndex < tabs.length) {
      setTabIndex(nextIndex.toString());
    }
  };

  const handleBack = () => {
    if (tabIndex === '0') {
      window.location.href = Pedido;
      return;
    }

    // marca a aba atual como visitada ao voltar
    markTabTouched(tabIndex);

    let prevIndex = parseInt(tabIndex) - 1;

    while (prevIndex >= 0 && isTabBlocked(prevIndex.toString())) {
      prevIndex--;
    }

    if (prevIndex >= 0) {
      setTabIndex(prevIndex.toString());
    }
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    // marca a aba que está sendo deixada como visitada
    markTabTouched(tabIndex);

    setTabIndex(newValue);
  };

  const handleSearchTransport = async (value: string) => {
    const result = await ClienteController.ListarTransportador(value);

    if (result.StatusCode === 200) {
      setTransportOptions(
        result.Data.map((item: any) => {
          return {
            value: item.cli_id,
            label: item.cli_nome,
          };
        })
      );
    }
  };

  const handleSearchCustomer = async (value: string) => {
    if (!value) return;
    if (form.values?.cadastro?.cli_nome) {
      if (form.values.cadastro.cli_nome.toLowerCase() == value.toLowerCase())
        return;
    }
    const result = await ClienteController.Listar({
      Bairro: '',
      Celular: '',
      Cidade: '',
      ClienteId: '',
      DataNascimento: '',
      Endereco: '',
      Nome: value,
      ClienteAtivo: 'A',
    });

    if (result.StatusCode === 200) {
      setCustomerList(result.Data);
      setCustomerOptions(
        result.Data.map((item: any) => {
          return {
            value: item.cli_id,
            label: item.cli_nome,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelected = (value: SelectAutoCompleteOptions) => {
    if (!value) {
      form.setFieldValue('cadastro.cli_id', null);
      form.setFieldValue('cadastro.cli_nome', null);
      form.setFieldValue('cadastro.cli_cep', null);
      form.setFieldValue('cadastro.cli_uf', null);
      form.setFieldValue('cadastro.cli_cidade', null);
      form.setFieldValue('cadastro.cli_bairro', null);
      form.setFieldValue('cadastro.cli_endereco', null);
      form.setFieldValue('cadastro.cli_numero', null);
      form.setFieldValue('cadastro.cli_complemento', null);
      return;
    }
    const customer = customerList.find(
      (item: any) => item.cli_id == value.value
    );
    form.setFieldValue('cadastro.cli_id', customer.cli_id);
    form.setFieldValue('cadastro.cli_nome', customer.cli_nome);
    form.setFieldValue('cadastro.cli_cep', customer.cli_cep);
    form.setFieldValue('cadastro.cli_uf', customer.cli_uf);
    form.setFieldValue('cadastro.cli_cidade', customer.cli_cidade);
    form.setFieldValue('cadastro.cli_bairro', customer.cli_bairro);
    form.setFieldValue('cadastro.cli_endereco', customer.cli_endereco);
    form.setFieldValue('cadastro.cli_numero', customer.cli_numero);
    form.setFieldValue('cadastro.cli_complemento', customer.cli_complemento);

    if (form.values?.cadastro?.endereco_alternativo == 'S') return;

    form.setFieldValue(
      'entrega.cep',
      removeSpecialCharacters(customer.cli_cep)
    );
    form.setFieldValue('entrega.uf', customer.cli_uf);
    form.setFieldValue('entrega.cidade', customer.cli_cidade);
    form.setFieldValue('entrega.bairro', customer.cli_bairro);
    form.setFieldValue('entrega.endereco', customer.cli_endereco);
    form.setFieldValue('entrega.numero', customer.cli_numero);
    form.setFieldValue('entrega.complemento', customer.cli_complemento);
  };

  const handleSearchSeller = async (value: string) => {
    if (!value) return;
    if (form.values?.cadastro?.vend_nome) {
      if (form.values.cadastro.vend_nome.toLowerCase() == value.toLowerCase())
        return;
    }
    const result = await ClienteController.ListarVendedor(value);

    if (result.StatusCode === 200) {
      setSellerOptions(
        result.Data.map((item: any) => {
          return {
            value: item.cli_id,
            label: item.cli_nome,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelectedSeller = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) {
      form.setFieldValue('cadastro.vend_id', null);
      form.setFieldValue('cadastro.vend_nome', null);
      return;
    }
    form.setFieldValue('cadastro.vend_id', value.value);
    form.setFieldValue('cadastro.vend_nome', value.label);
  };

  const handleAutoCompleteSelectedTransport = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;
    form.setFieldValue('transporte.transportador_id', value.value);
    form.setFieldValue('transporte.cli_nome', value.label);
  };

  const handleCloseModalSearchProduct = () => {
    setModalSearchProduct(false);
    setProductIsEditing(false);
    setActiveProductSelected(null);
    handleResetFormProduct();
    setShowCreateProduct(false);
  };

  const handleCloseModalSearchService = () => {
    setModalSearchService(false);
    setServiceIsEditing(false);
    setActiveServiceSelected(null);
    setActiveCodigoNBSSelected(null);
    setActiveCodigoTributarioSelected(null);
    handleResetFormService();
    setShowCreateProduct(false);
  };

  const handleOpenModalSearchProduct = () => {
    setModalSearchProduct(true);
    setShowCreateProduct(false);
  };

  const handleOpenModalSearchService = () => {
    setModalSearchService(true);
    setShowCreateProduct(false);
  };

  const handleSearchProduct = async (value: string, type: string) => {
    if (!value && !type) return;

    const products = await ProdutoController.Listar({
      Descricao: value,
      Comissao: null,
      ProdutoId_Promatec: '',
      CodigoBarras: '',
      Tipo: '',
      Grupo: type === 'servico' ? '32' : '',
      PartNumber: '',
    });

    if (products?.Data?.length) {
      setAllProductList(products.Data);
      setProductOptions(
        products.Data.map((item: any) => {
          return {
            label: item.prod_descricao,
            value: item.prod_id,
          };
        })
      );
      setShowCreateProduct(false);
    }
    else {
      setProductOptions([]);
      setShowCreateProduct(true);
    }
  };

  const handleSearchCodigoTributario = async (value: string) => {
    if (!value) return;

    const codigos = await ImpostoController.consultaCodigoTributacao({
      Descricao: value,
    });

    if (codigos?.length) {
      setAllCodigoTributarioList(codigos);
      setCodigoTributarioOptions(
        codigos.map((item: any) => {
          return {
            label: item.cnt_descricao,
            value: item.cnt_id,
          };
        })
      );
    } else {
      // Sem este else a lista da busca ANTERIOR continuava na tela, e dava para
      // escolher um codigo que nao tem nada a ver com o que foi digitado.
      setAllCodigoTributarioList([]);
      setCodigoTributarioOptions([]);
    }
  };

  const handleAutoCompleteSelectedCodigoTributario = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;
    const codigoTributario = allCodigoTributarioList.find((item: any) => {
      return item.cnt_id === value.value;
    });
    formService.setFieldValue('cnt_id', codigoTributario?.cnt_id ?? null);
    formService.setFieldValue(
      'cnt_descricao',
      codigoTributario?.cnt_descricao ?? null
    );
    setActiveCodigoTributarioSelected(codigoTributario);
  };

  const handleAutoCompleteSelectedCodigoNBS = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;
    const codigoNBS = allCodigoNBSList.find((item: any) => {
      return item.cnbs_id === value.value;
    });
    formService.setFieldValue('cnbs_id', codigoNBS?.cnbs_id ?? null);
    formService.setFieldValue(
      'cnbs_descricao',
      codigoNBS?.cnbs_descricao ?? null
    );
    setActiveCodigoNBSSelected(codigoNBS);
  };

  const handleSearchCodigoNBS = async (value: string) => {
    if (!value) return;

    const codigos = await ImpostoController.consultaNBS({
      Descricao: value,
    });

    // Esta busca mexe SO no estado do NBS. Antes ela chamava setProductOptions([]) e
    // setShowCreateProduct(...) - copiado da busca de produto -, e o efeito era que
    // procurar um NBS inexistente apagava o produto ja selecionado na tela e oferecia
    // "Criar produto". Quem manda em showCreateProduct e a busca de produto.
    if (codigos?.length) {
      setAllCodigoNBSList(codigos);
      setCodigoNBSOptions(
        codigos.map((item: any) => {
          return {
            label: item.cnbs_descricao,
            value: item.cnbs_id,
          };
        })
      );
    } else {
      setAllCodigoNBSList([]);
      setCodigoNBSOptions([]);
    }
  };

  const handleAutoCompleteSelectedProduct = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;
    const product = allProductList.find((item: any) => {
      return item.prod_id === value.value;
    });
    formProduct.setFieldValue(
      'peso_liquido_kg',
      product?.prod_peso_liquido ?? 0
    );
    formProduct.setFieldValue('peso_bruto_kg', product?.prod_peso_bruto ?? 0);
    formProduct.setFieldValue('lote', product?.prod_lote ?? '');
    formProduct.setFieldValue('value', product?.preco_venda);
    formProduct.setFieldValue('estoque', product?.prod_estoque ?? '');
    formProduct.setFieldValue('numero_pedido_compra', product?.ven_id ?? '');
    formProduct.setFieldValue(
      'numero_item_pedido_compra',
      product?.vndprod_id ?? ''
    );
    formProduct.setFieldValue(
      'prod_armazem',
      product?.prod_armazem ?? 'ARMAZÉM PADRÃO'
    );
    setActiveProductSelected(product);
  };

  const handleAutoCompleteSelectedService = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;
    const product = allProductList.find((item: any) => {
      return item.prod_id === value.value;
    });
    formService.setFieldValue('value', product?.preco_venda ?? 0);
    setActiveServiceSelected(product);
  };

  const handleTotalFormProduct = () => {
    const value = formProduct.values.value;
    const quantidade = parseInt(formProduct.values.quantidade) || 0;
    const desconto = formProduct.values.desconto || 0;

    const total = value * quantidade - desconto;

    formProduct.setFieldValue('total', total);
    formProduct.setFieldValue(
      'peso_liquido_total_kg',
      quantidade * (formProduct.values?.peso_liquido_kg ?? 0)
    );
    formProduct.setFieldValue(
      'peso_bruto_total_kg',
      quantidade * (formProduct.values?.peso_bruto_kg ?? 0)
    );

    formProduct.setFieldValue(
      'desconto_rateado',
      desconto == 0 ? 0 : desconto / quantidade
    );
  };

  const handleTotalFormService = () => {
    const value = formService.values.value;
    const quantidade = parseInt(formService.values.quantidade) || 0;
    const desconto = formService.values.desconto || 0;

    const total = value * quantidade - desconto;

    formService.setFieldValue('total', total);

    formService.setFieldValue(
      'desconto_rateado',
      desconto == 0 ? 0 : desconto / quantidade
    );
  };

  const handleDeleteProduct = (product: any) => {
    const productList = form.values.products_list.filter(
      (_: any, index: number) => index !== product.id
    );
    form.setFieldValue('products_list', productList);
    toast('Excluído com sucesso', { type: 'success' });
  };

  const handleDeleteService = (product: any) => {
    const productList = form.values.services_list.filter(
      (_: any, index: number) => index !== product.id
    );
    form.setFieldValue('services_list', productList);
    toast('Excluído com sucesso', { type: 'success' });
  };

  const handleDeleteMachine = (product: any) => {
    const productList = form.values.locacao.locacao_list.filter(
      (_: any, index: number) => index !== product.id
    );
    form.setFieldValue('locacao.locacao_list', productList);
    toast('Excluído com sucesso', { type: 'success' });
  };

  const handleEditProduct = (product: any) => {
    setProductIsEditing(true);
    formProduct.setValues(product);
    setActiveProductSelected(product);
    setModalSearchProduct(true);
  };

  const handleEditService = (service: any) => {
    setServiceIsEditing(true);
    formService.setValues(service);
    setActiveServiceSelected(service);
    setActiveCodigoNBSSelected(service);
    setActiveCodigoTributarioSelected(service);
    setModalSearchService(true);
  };

  const handleTotalLocacao = () => {
    if (form.values.locacao) {
      const total = form.values.locacao.valor || 0;
      form.setFieldValue('financeiro.total_liquido_locacao', total);
      form.setFieldValue('finalizar.total_locacao_bruto', total);
    }
  };

  const handleTotalProductValue = () => {
    if (form.values.products_list) {
      const total = form.values.products_list.reduce(
        (acc: number, value: any) => acc + value.total,
        0
      );
      const totalBruto = form.values.products_list.reduce(
        (acc: number, value: any) => acc + value.value * value.quantidade,
        0
      );
      form.setFieldValue('financeiro.total_liquido_produtos', total);
      form.setFieldValue('finalizar.total_bruto_produtos', totalBruto);
    }
  };

  const handleTotalServiceValue = () => {
    const total = form.values.services_list.reduce(
      (acc: number, value: any) => acc + value.total,
      0
    );
    const totalBruto = form.values.services_list.reduce(
      (acc: number, value: any) => acc + value.value * value.quantidade,
      0
    );
    form.setFieldValue('financeiro.total_liquido_servicos', total);
    form.setFieldValue('finalizar.total_servicos_bruto', totalBruto);
  };

  const handleTotalServiceAndProductValue = () => {
    const totalService = form.values?.financeiro?.total_liquido_servicos ?? 0;
    const totalProduct = form.values?.financeiro?.total_liquido_produtos ?? 0;
    const totalLocacao = form.values?.locacao?.valor ?? 0;
    form.setFieldValue(
      'financeiro.total_geral',
      totalProduct + totalService + totalLocacao
    );
  };

  const handleTotalLiquidoPedido = () => {
    const totalProduto = form.values?.finalizar?.total_bruto_produtos ?? 0;
    const totalProdutoDesconto = form?.values?.products_list?.reduce(
      (acc: number, value: any) => acc + value.desconto,
      0
    );
    const totalService = form.values?.finalizar?.total_servicos_bruto ?? 0;
    const totalServioDesconto = form?.values?.services_list?.reduce(
      (acc: number, value: any) => acc + value.desconto,
      0
    );
    // O campo gravado e "total_locacao_bruto" (ver initialValues e handleTotalLocacao);
    // aqui lia-se "total_bruto_locacao" - nomes trocados, entao a locacao entrava como 0
    // e o Total Liquido do Pedido saia zerado. Cai para locacao.valor por seguranca.
    const totalLocacao = Number(
      form.values?.finalizar?.total_locacao_bruto ?? form.values?.locacao?.valor ?? 0
    ) || 0;

    const modalidadeFrete = form?.values?.transporte?.mod_frete;

    // [BONIFICACAO 14/08/2026 - J.6] Na bonificacao integral o frete NAO e cobrado do
    // cliente, entao nao entra no total. A modalidade continua sendo declarada
    // normalmente (transp_mod_frete vai ao XML de qualquer jeito) - o que se anula e o
    // VALOR, nao a informacao. E por isso que aqui zera o total em vez de mexer no
    // mod_frete escolhido pelo usuario.
    const bonificacaoIntegral = ehBonificacaoIntegral(form.values);

    const totalFrete =
      !bonificacaoIntegral &&
      (modalidadeFrete == 1 || form?.values?.transporte?.somar_frete_cif == 'S')
        ? (form.values?.transporte?.valor_frete ?? 0)
        : 0;
    const totalBruto = totalProduto + totalService + totalLocacao;
    const totalDesconto = totalProdutoDesconto + totalServioDesconto;

    if (modalidadeFrete != 0) {
      form.setFieldValue('transporte.somar_frete_cif', 'N');
    }

    form.setFieldValue(
      'finalizar.total_liquido_pedido',
      totalBruto - totalDesconto + totalFrete
    );
    form.setFieldValue('finalizar.desconto_itens', totalDesconto);
    form.setFieldValue('finalizar.total_descontos', totalDesconto);
    form.setFieldValue('finalizar.valor_frete', totalFrete);
  };

  const handleSelectOptions = () => {
    handlePaymentOptions();
    handlePaymentConditionOptions();
    handleCostCenterOptions();
    handleCfopOptions();
    if (id) {
      getPedidoDetalhes();
    }
  };

  const getPedidoDetalhes = async () => {
    setLoading(true);
    const result = await PedidoController.ListarUnico(id!);
    setLoading(false);
    if (result.StatusCode !== 200) return;
    form.setValues(comDataReferencia(result.Data));
  };

  // A data de referência é obrigatória, mas as vendas geradas por Ordem de Serviço
  // (criadas antes de 07/08/2026) foram gravadas sem ela. Resultado: a tela não
  // salvava e não dizia por quê — o erro fica na aba Financeiro e o Salvar está na
  // última aba.
  //
  // Cair para a data de emissão não é invenção da tela: é a mesma regra que o banco
  // já usa para calcular vencimentos — COALESCE(vnd_data_referencia, vnd_data_emissao)
  // na PROC_CONTAS_RECEBER_BOLETO_GRAVAR. Aqui só a tornamos visível.
  const comDataReferencia = (dados: any) => {
    if (!dados) return dados;
    if (dados?.financeiro?.data_referencia) return dados;

    const emissao = dados?.cadastro?.data_emissao;
    if (!emissao) return dados;

    return {
      ...dados,
      financeiro: {
        ...dados.financeiro,
        data_referencia: String(emissao).slice(0, 10), // InputDate espera YYYY-MM-DD
      },
    };
  };

  /**
   * Quantos itens o pedido tem, somando as três origens.
   *
   * A regra de negócio é "o pedido precisa de ao menos UM item", e não "cada aba
   * precisa dos seus". Um pedido só de serviços é legítimo; um só de produtos
   * também. Ver validateTab.
   */
  const totalDeItensDoPedido = (() => {
    const contar = (lista: any) => (Array.isArray(lista) ? lista.length : 0);
    return (
      contar(form.values?.products_list) +
      contar(form.values?.services_list) +
      contar(form.values?.locacao?.locacao_list)
    );
  })();

  /**
   * O que está pendente numa aba, em texto, para o `title` da aba.
   *
   * Existe porque o `!` sozinho não diz nada: o usuário vê a marca, confere os
   * campos que enxerga, acha tudo preenchido e conclui que o sistema está errado -
   * exatamente a reclamação que originou esta correção. Passando o mouse na aba ele
   * lê o que falta.
   *
   * Devolve string vazia quando não há pendência.
   */
  const pendenciasDaAba = (value: string): string => {
    if (value === 'products_list' || value === 'services_list') {
      return totalDeItensDoPedido === 0
        ? 'Adicione ao menos um item ao pedido (produto, serviço ou máquina).'
        : '';
    }

    const erros = form.errors?.[value];
    if (!erros) return '';

    // 'financeiro.data_referencia' -> 'data referencia'
    const campos = caminhosComErro(erros)
      .map((caminho) => caminho.split(/[.[]/).filter(Boolean).pop() ?? caminho)
      .map((nome) => nome.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2'))
      .filter((nome, i, todos) => todos.indexOf(nome) === i);

    if (campos.length === 0) return '';
    return 'Falta preencher: ' + campos.join(', ') + '.';
  };

  const validateTab = (value: string) => {
    const tab = tabs.find((item: any) => item.value === value);

    /* [CORRIGIDO 21/08/2026] Três regras mudaram aqui, e cada uma tinha um motivo
       para o `!` aparecer sem pendência nenhuma:

       1. Aba DESABILITADA pela finalidade nunca acusa. Produtos e Serviços ficam
          cinzas numa venda de Locação, e Locação fica cinza nas outras - acusar
          pendência num lugar que o usuário não consegue nem abrir é beco sem saída.

       2. Produtos e Serviços não exigem item CADA UM. A regra é o pedido ter ao
          menos um item no total; pedido só de serviço é legítimo, e era este o
          caso da reclamação: a aba Serviço sinalizava pendência por estar vazia,
          num pedido que não vende serviço nenhum.

       3. O ícone agora concorda com o que impede salvar - `form.errors` é a mesma
          fonte que o Salvar consulta. Antes as listas usavam uma regra própria,
          que podia acusar pendência com o formulário inteiro válido. */

    // 1. desabilitada pela finalidade
    if (tab && isTabBlocked(tab.id)) {
      return <RemoveCircleOutline color='disabled' />;
    }

    // Ainda não visitada → ícone neutro
    if (!tab?.touched) {
      return <RemoveCircleOutline color='disabled' />;
    }

    return pendenciasDaAba(value) ? (
      <ErrorSharp color='warning' />
    ) : (
      <CheckCircle color='success' />
    );
  };

  const handleZipCode = async (value: any) => {
    form.handleChange(value);
    const zipcode = value.target.value;

    // @ts-ignore - .
    if (zipcode && removeSpecialCharacters(zipcode).length >= 8) {
      form.handleTextChange('entrega.cep', removeSpecialCharacters(zipcode));
      setLoading(true);
      const response = await getAddressData(zipcode);

      if (response && response.uf) {
        form.handleTextChange('entrega.cidade', response.localidade);
        form.handleTextChange('entrega.uf', response.uf);
        form.handleTextChange('entrega.endereco', response.logradouro);
        form.handleTextChange('entrega.bairro', response.bairro);
      } else {
        form.handleTextChange('entrega.cidade', null);
        form.handleTextChange('entrega.uf', null);
        form.handleTextChange('entrega.endereco', null);
        form.handleTextChange('entrega.bairro', null);
      }
      setLoading(false);
    }
  };

  const handleAddress = () => {
    if (form.values?.cadastro?.endereco_alternativo == 'S') return;

    form.setFieldValue(
      'entrega.cep',
      removeSpecialCharacters(form.values?.cadastro?.cli_cep) ?? null
    );
    form.setFieldValue('entrega.uf', form.values?.cadastro?.cli_uf ?? null);
    form.setFieldValue(
      'entrega.cidade',
      form.values?.cadastro?.cli_cidade ?? null
    );
    form.setFieldValue(
      'entrega.bairro',
      form.values?.cadastro?.cli_bairro ?? null
    );
    form.setFieldValue(
      'entrega.endereco',
      form.values?.cadastro?.cli_endereco ?? null
    );
    form.setFieldValue(
      'entrega.numero',
      form.values?.cadastro?.cli_numero ?? null
    );
    form.setFieldValue(
      'entrega.complemento',
      form.values?.cadastro?.cli_complemento ?? null
    );
  };

  useEffect(() => {
    handleSelectOptions();
  }, []);

  useEffect(() => {
    handleTotalFormProduct();
  }, [
    formProduct.values.value,
    formProduct.values.quantidade,
    formProduct.values.desconto,
    formProduct.values.peso_bruto_kg,
    formProduct.values.peso_liquido_kg,
  ]);

  useEffect(() => {
    handleAddress();
  }, [form.values?.cadastro?.endereco_alternativo]);

  useEffect(() => {
    handleTotalFormService();
  }, [
    formService.values.value,
    formService.values.quantidade,
    formService.values.desconto,
  ]);

  useEffect(() => {
    handleTotalLocacao();
  }, [form.values.locacao?.valor]);

  useEffect(() => {
    handleTotalProductValue();
  }, [form.values.products_list]);

  useEffect(() => {
    handleTotalServiceValue();
  }, [form.values.services_list]);

  useEffect(() => {
    handleTotalServiceAndProductValue();
    handleTotalLiquidoPedido();
  }, [
    form.values.financeiro?.total_liquido_servicos,
    form.values.financeiro?.total_liquido_produtos,
    form.values.financeiro?.total_liquido_locacao,
  ]);

  useEffect(() => {
    handleTotalLiquidoPedido();
  }, [
    form.values.finalizar?.total_servicos_bruto,
    form.values.finalizar?.total_bruto_produtos,
    form.values.transporte?.valor_frete,
    form?.values.locacao?.valor,
    form?.values?.transporte?.mod_frete,
    form?.values?.transporte?.somar_frete_cif,
  ]);

  // [BONIFICACAO 14/08/2026 - J.5] Venda 100% bonificada nao tem o que cobrar, entao nao
  // pode exigir forma nem condicao de pagamento. Em vez de mexer no PedidoDetalheSchema,
  // desliga o "Gerar financeiro": o schema JA condiciona o cpg_id a essa flag (ajuste de
  // 07/08/2026) e tpg_id nunca foi exigido ali. Ou seja, a regra do item F do banco
  // ("exige quando o cobravel > 0") passa a valer na tela sem duplicar validacao.
  //
  // Espelha a decisao 2 do card: marcacao DERIVADA dos itens, sem toggle novo. Venda
  // MISTA nao cai aqui e segue exigindo tudo.
  //
  // Nao religa o financeiro sozinho ao deixar de ser integral: se o usuario tirar o item
  // bonificado, ele reencontra o campo obrigatorio e decide - religar por conta propria
  // sobrescreveria uma escolha que pode ter sido dele.
  useEffect(() => {
    if (!ehBonificacaoIntegral(form.values)) return;

    if (form.values?.financeiro?.gerar_financeiro) {
      form.setFieldValue('financeiro.gerar_financeiro', false);
    }
    if (form.values?.transporte?.somar_frete_cif === 'S') {
      form.setFieldValue('transporte.somar_frete_cif', 'N');
    }
  }, [
    form.values?.products_list,
    form.values?.services_list,
    form.values?.locacao?.valor,
  ]);

  // Simula as parcelas/boletos a partir da condicao de pagamento selecionada.
  // Persiste em form.values.financeiro.parcelas (mantido em memoria entre as etapas).
  useEffect(() => {
    const simularParcelas = async () => {
      const fin = form.values?.financeiro;
      if (
        !fin?.gerar_financeiro ||
        !fin?.cpg_id ||
        !fin?.total_geral ||
        !fin?.data_referencia
      ) {
        form.setFieldValue('financeiro.parcelas', []);
        return;
      }

      /* [30/09] A previa sai pelo que o cliente AINDA deve, ja abatido o credito - e o
         que a PROC_CONTAS_RECEBER_BOLETO_GRAVAR vai gerar de verdade (FN_VENDA_TOTAL_A_
         RECEBER, script 141). Sem isso a tela mostrava 3 x 306,33 com R$ 382,60 de
         credito informado, e o cliente recebia 3 x 178,80.

         Locacao nao abate: la cada parcela e o valor mensal cheio, e o banco recusa
         credito em locacao. */
      const ehLocacao = form.values?.finalidade?.finalidade === 'Locação';
      const num = (v: any) => {
        const n = Number(v ?? 0);
        return Number.isFinite(n) ? n : 0;
      };

      /* [30/09] A MESMA conta da FN_VENDA_TOTAL_LIQUIDO, que e de onde o banco reparte:
         total geral - item bonificado + frete cobrado. Antes a previa partia so do total
         geral e ignorava o frete - no pedido 185 (R$ 15 de frete) mostrava parcelas de
         273,00 enquanto o banco gerou 278,00. A diferenca ja existia antes do credito; so
         ficou visivel quando alguem foi conferir o grid contra os titulos.

         O frete segue a regra da FN_FRETE_COBRADO, igual a comTotaisRecalculados.

         Locacao fica como era: la cada parcela e o valor mensal cheio, SEM frete (frete e
         cobranca unica), e o banco recusa credito. */
      const bonificados = (Array.isArray(form.values?.products_list) ? form.values.products_list : [])
        .filter(itemEhBonificado)
        .reduce((soma: number, item: any) => soma + num(item?.total), 0);
      const transporte = form.values?.transporte;
      const frete = String(transporte?.mod_frete) === '1' || transporte?.somar_frete_cif === 'S'
        ? num(transporte?.valor_frete)
        : 0;

      const liquido = ehLocacao ? num(fin.total_geral) : num(fin.total_geral) - bonificados + frete;
      const credito = ehLocacao ? 0 : num(fin.valor_credito_utilizado);
      const aReceber = liquido - credito;

      /* Credito cobrindo tudo: nenhuma parcela - o banco tambem nao gera. */
      if (aReceber <= 0.004) {
        form.setFieldValue('financeiro.parcelas', []);
        return;
      }

      const result = await CondicaoPagamentoController.SimularParcelas({
        CondicaoPagamentoId: Number(fin.cpg_id),
        ValorTotal: aReceber,
        DataReferencia: fin.data_referencia,
        // [24/09] Fixo em 'N'. O "Recebimento único" saiu da tela: ele mudava ESTA
        // prévia e nada mais - a PROC_CONTAS_RECEBER_BOLETO_GRAVAR, que cria os títulos
        // de verdade, nunca leu o campo (medido no script 104). Marcado, a tela
        // prometia uma parcela e o cliente recebia N boletos.
        RecebimentoUnico: 'N',
        // Locacao: repete o mesmo valor em cada parcela (nao divide).
        RepetirValor: form.values?.finalidade?.finalidade === 'Locação' ? 'S' : 'N',
      });

      if (result.StatusCode === 200 && Array.isArray(result.Data)) {
        form.setFieldValue(
          'financeiro.parcelas',
          result.Data.map((p: any, i: number) => ({
            id: i + 1,
            parcela_numero: p.parcela_numero,
            data_vencimento: p.data_vencimento,
            valor: p.valor,
          }))
        );
      } else {
        form.setFieldValue('financeiro.parcelas', []);
      }
    };

    simularParcelas();
  }, [
    form.values.financeiro?.cpg_id,
    form.values.financeiro?.total_geral,
    form.values.financeiro?.data_referencia,
    form.values.financeiro?.gerar_financeiro,
    // [30/09] Refaz a previa quando o credito, o frete ou os itens mudam - sao as
    // parcelas da conta que o banco faz.
    form.values.financeiro?.valor_credito_utilizado,
    form.values.transporte?.valor_frete,
    form.values.transporte?.mod_frete,
    form.values.transporte?.somar_frete_cif,
    form.values.products_list,
  ]);

  const debouncedSearchCustomer = debounce(handleSearchCustomer, 400);
  const debouncedSearchSeller = debounce(handleSearchSeller, 400);
  const debouncedSearchTransport = debounce(handleSearchTransport, 400);
  const debouncedSearchProduct = debounce(handleSearchProduct, 400);
  const debouncedSearchCodigoTributo = debounce(
    handleSearchCodigoTributario,
    400
  );
  const debouncedSearchCodigoNBS = debounce(handleSearchCodigoNBS, 400);

  // ---------------------------------------------------------------------------
  // Salvar: dizer POR QUE não salvou
  // ---------------------------------------------------------------------------
  // O Formik não chama o onSubmit quando a validação reprova - ele só marca os
  // campos. Como o botão Salvar fica na ÚLTIMA aba e os obrigatórios estão
  // espalhadas pelas outras (e às vezes numa aba desabilitada, como Locação numa
  // venda Normal), da tela isso aparece como "cliquei em salvar e não aconteceu
  // nada". Três chamados diferentes em 07/08/2026 eram esse mesmo silêncio.
  //
  // Agora o clique sempre responde: ou salva, ou diz o que falta e em qual aba.
  const caminhosComErro = (erros: any, prefixo = ''): string[] => {
    if (!erros) return [];
    if (typeof erros === 'string') return [prefixo];
    if (Array.isArray(erros))
      return erros.flatMap((item, i) => caminhosComErro(item, `${prefixo}[${i}]`));
    return Object.keys(erros).flatMap((chave) =>
      caminhosComErro(erros[chave], prefixo ? `${prefixo}.${chave}` : chave)
    );
  };

  const abasComErro = (erros: any): string[] => {
    const raizes = new Set(
      caminhosComErro(erros).map((caminho) => caminho.split(/[.[]/)[0])
    );
    return Array.from(raizes).map((raiz) => {
      const aba = tabs.find((item: any) => item.value === raiz);
      return aba?.label ?? raiz;
    });
  };

  const handleSubmitComAviso = async (event?: any) => {
    event?.preventDefault?.();

    const erros = await form.validateForm();

    if (erros && Object.keys(erros).length > 0) {
      const abas = abasComErro(erros);
      toast(
        `Não foi possível salvar. Revise os campos obrigatórios em: ${abas.join(', ')}.`,
        { type: 'error', autoClose: 6000 }
      );
    }

    // Segue para o Formik de qualquer forma: é ele que marca os campos como
    // tocados e pinta os erros na tela, e que chama o onSubmit quando está tudo
    // certo. O aviso acima é só o que faltava.
    form.handleSubmit(event);
  };

  return {
    ...form,
    handleSubmit: handleSubmitComAviso,
    handleNext,
    handleBack,
    isTabBlocked,
    handleTabChange,
    loading,
    tabIndex,
    customerOptions,
    handleSearchCustomer: debouncedSearchCustomer,
    handleAutoCompleteSelected,
    sellerOptions,
    handleSearchSeller: debouncedSearchSeller,
    handleAutoCompleteSelectedSeller,
    // Saem com a regra forma x condição já aplicada (ver paymentOptionsComRegra).
    // A tela consome pelos mesmos nomes de antes, então nada mudou lá.
    paymentOptions: paymentOptionsComRegra,
    transportOptions,
    handleSearchTransport: debouncedSearchTransport,
    handleAutoCompleteSelectedTransport,
    paymentConditionOptions: paymentConditionOptionsComRegra,
    // A tela usa para desabilitar o select de condição e explicar o porquê.
    temFormaPagamentoSelecionada: temFormaSelecionada,
    reprocessarBoleto,
    reprocessandoBoleto,
    handleReprocessarBoletoVenda,
    travadoPorBoleto,
    handleCloseModalSearchProduct,
    modalSearchProduct,
    productOptions,
    showCreateProduct,
    handleCreateProduct: () => window.open(ProdutoCadastrar, '_blank'),
    handleSearchProduct: debouncedSearchProduct,
    handleAutoCompleteSelectedProduct,
    handleOpenModalSearchProduct,
    formProduct,
    activeProductSelected,
    handleDeleteProduct,
    handleEditProduct,
    productIsEditing,
    costCenterOptions,
    formService,
    handleCloseModalSearchService,
    serviceIsEditing,
    activeServiceSelected,
    modalSearchService,
    cfopOptions,
    handleOpenModalSearchService,
    handleEditService,
    handleDeleteService,
    handleDeleteMachine,
    handleAutoCompleteSelectedService,
    validateTab,
    pendenciasDaAba,
    tabs,
    handleZipCode,
    handleSearchCodigoTributario: debouncedSearchCodigoTributo,
    handleAutoCompleteSelectedCodigoTributario,
    activeCodigoTributarioSelected,
    codigoTributarioOptions,
    codigoNBSOptions,
    activeCodigoNBSSelected,
    handleAutoCompleteSelectedCodigoNBS,
    handleSearchCodigoNBS: debouncedSearchCodigoNBS,
    BoletoOpen,
    boletoApiResponse,
    boletoHandleOk,
    handleReprocessarBoletos,
    boletoReprocessing
  };
};

export default usePedidoDetalhes;
